import { render } from "./SettingsView.vue?vue&type=template&id=2423c282&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=2423c282&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2423c282"]])

export default __exports__